import type { CustomerState } from '../types';

const transitions: Record<CustomerState, CustomerState[]> = {
  ARRIVING: ['WAITING_FOR_SEAT', 'ANGRY_LEAVING'],
  WAITING_FOR_SEAT: ['WALKING_TO_TABLE', 'ANGRY_LEAVING'],
  WALKING_TO_TABLE: ['DECIDING', 'ANGRY_LEAVING'],
  DECIDING: ['WAITING_TO_ORDER', 'ANGRY_LEAVING'],
  WAITING_TO_ORDER: ['WAITING_FOR_FOOD', 'ANGRY_LEAVING'],
  WAITING_FOR_FOOD: ['EATING', 'ANGRY_LEAVING'],
  EATING: ['WAITING_TO_PAY'],
  WAITING_TO_PAY: ['LEAVING', 'ANGRY_LEAVING'],
  LEAVING: [],
  ANGRY_LEAVING: [],
};

export class CustomerStateMachine {
  private current: CustomerState;

  constructor(initial: CustomerState = 'ARRIVING') {
    this.current = initial;
  }

  get state(): CustomerState {
    return this.current;
  }

  canTransition(next: CustomerState): boolean {
    return transitions[this.current].includes(next);
  }

  transition(next: CustomerState): void {
    if (!this.canTransition(next)) {
      throw new Error(`Invalid customer transition: ${this.current} -> ${next}`);
    }
    this.current = next;
  }
}
